import { Avatar, Box, Card, CardContent, Typography, styled, Tooltip } from "@mui/material";
import BallotIcon from '@mui/icons-material/Ballot';
import FenceIcon from '@mui/icons-material/Fence';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import { FC } from "react";
import { Link as RouterLink } from 'react-router-dom'

export const TileEntryLink = styled(RouterLink)({
  textDecorationLine: 'none',
})

export const TileContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& .MuiAvatar-root': {
    width: 112, 
    height: 112, 
    backgroundColor: 'rgba(86, 100, 210, 0.08)',
    marginTop: theme.spacing(2),
    '& .MuiSvgIcon-root': {
      fontSize: 45,
      color: theme.palette.primary.main,
    },
  },
  '& > h6': {
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
}))

export const CreateFileCatalogTile: FC = () => {
  return (
    <TileEntryLink to="/secure-files/file-catalog">
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <BallotIcon/>
            </Avatar>
            <Typography variant="h6">
              File Catalog
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const CreateFileAuditTile: FC = () => {
  return (
    <TileEntryLink to="/secure-files/file-access-log">
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              
            </Avatar>
            <Typography variant="h6">
              File Access Log
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const CreateFileClassificationTile: FC = () => {
  return (
    <TileEntryLink to="/secure-files/dashboard" sx={{ cursor: 'default' }} >
      <Tooltip title="This feature will be available in next release.">
        <Card>
          <CardContent>
            <TileContent
              sx={{
                '& .MuiAvatar-root': {
                  bgcolor: 'action.disabledBackground',
                  '& .MuiSvgIcon-root': {
                    color: 'action.disabled'
                  },
                },
                '& > h6': {
                  color: 'text.disabled'
                }
              }}>
              <Avatar>
                <RunningWithErrorsIcon />                
              </Avatar>
              <Typography variant="h6">
                File Classification
              </Typography>
            </TileContent>
          </CardContent>
        </Card>
      </Tooltip>
    </TileEntryLink>
  )
}

export const CreateFileOwnershipTile: FC = () => {
  return (
    <TileEntryLink to="/secure-files/dashboard" sx={{ cursor: 'default' }} >
      <Tooltip title="This feature will be available in next release.">
        <Card>
          <CardContent>
            <TileContent 
              sx={{
                '& .MuiAvatar-root': {
                  bgcolor: 'action.disabledBackground',
                  '& .MuiSvgIcon-root': {
                    color: 'action.disabled'
                  },
                },
                '& > h6': {
                  color: 'text.disabled'
                }
              }}>
              <Avatar>
                <FenceIcon />
              </Avatar>
              <Typography variant="h6">
                File Ownership
              </Typography>
            </TileContent>
          </CardContent>
        </Card>
      </Tooltip>
    </TileEntryLink>
  )
}

export const OfflineFileSearchTile: FC = () => {
  return (
    <TileEntryLink to="/secure-files/offline-files" >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <WifiOffIcon />
            </Avatar>
            <Typography variant="h6">
              Offline Files
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}


